import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { AdminService } from './admin.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Main } from '@app/core/main.service';
import { NgxImageCompressService } from 'ngx-image-compress';


@Component({
    selector: 'cp-customer-detail',
    templateUrl: './customer.detail.component.html',
    styleUrls: ['./customer.detail.component.scss']
})
export class CustomerDetailComponent {
    customer: any;
    id: string;
    userId: string;
    filter: string;
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    customerEkubs: any = [];
    customerTransactions: any = [];
    notifications: any[];
    notification: any = {};
    awards: any[];
    sales: any[];
    offers: any[];
    notificationForm!: FormGroup;
    receiptForm!: FormGroup;
    avatarUrl: any;
    legalIdFrontUrl: any;
    legalIdBackUrl: any;
    typeFilter: string;
    statusFilter: string;
    ekubFilter: string;
    receiptStatusFilter: string;
    userStats: any = {};
    userAwards: any = [];
    baseUrl: string = environment.production
        ? environment.ONLINE_BASE_URL :
        environment.LOCAL_BASE_URL;

    guarantees: any = [];
    receipts: any = [];
    receipt: any = {};
    selectedReceipt: string;

    // receipt file upload

    file: any;
    files: File[] = [];
    files_temp: any = [];
    localUrl: any;
    localCompressedURl: any;
    sizeOfOriginalImage: number;
    sizeOFCompressedImage: number;
    imgResultBeforeCompress: string;
    imgResultAfterCompress: string;

    uploading = false;
    successUploadCount = 0;
    failedUploadCount = 0;
    error: string;
    uploadResponse = { status: '', message: '', filePath: '' };





    constructor(private api: AdminService,
        @Inject(Restangular) public Restangular, private route: ActivatedRoute, private mainService: Main, private formBuilder: FormBuilder,
        private imageCompress: NgxImageCompressService, private sanitizer: DomSanitizer) {
        this.filter = '';
        this.statusFilter = '';
        this.ekubFilter = '';
        this.receiptStatusFilter = '';
        this.typeFilter = '';
        this.itemsPerPage = 10;
        this.totalItems = 0;
        this.currentPage = 1;
        this.id = this.route.params['value']['id'];
        this.getCustomer(this.id);
        this.createForm();
    }


    get user() { return this.notificationForm.get('user'); }
    get title() { return this.notificationForm.get('title'); }
    get content() { return this.notificationForm.get('content'); }
    get status() { return this.notificationForm.get('status'); }
    get type() { return this.notificationForm.get('type'); }

    //get receiptUser() { return this.receiptForm.get('user'); }
    get ekub() { return this.receiptForm.get('ekub'); }
    get issued_date() { return this.receiptForm.get('issued_date'); }
    get ref_number() { return this.receiptForm.get('ref_number'); }
    get amount() { return this.receiptForm.get('amount'); }
    get vat() { return this.receiptForm.get('vat'); }
    get total() { return this.receiptForm.get('total'); }
    get receiptStatus() { return this.receiptForm.get('status'); }
    get remark() { return this.receiptForm.get('type'); }


    private createForm() {

        this.notificationForm = this.formBuilder.group({
            user: ['', [Validators.required,]],
            title: ['', [Validators.required,]],
            content: ['', [Validators.required,]],
            type: ['info', [Validators.required,]],
            status: ['unread', Validators.required],
        });

        this.receiptForm = this.formBuilder.group({
            //user: ['', [Validators.required,]],
            ekub: ['', [Validators.required,]],
            issued_date: ['', [Validators.required,]],
            ref_number: ['', [Validators.required,]],
            amount: [0, [Validators.required,]],
            vat: [0],
            total: [0, [Validators.required,]],
            status: ['pending', [Validators.required,]],
            remark: [''],
        });
    }

    getCustomer(customerId: any) {
        debugger;
        this.api.getProfile(customerId, this.filter).subscribe((resp: any) => {
            debugger;
            this.customer = resp.data;
            this.customerEkubs = resp.data.ekubs;
            this.avatarUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.customer.avatar}`);
            this.legalIdFrontUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.customer.id_front}`);
            this.legalIdBackUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.customer.id_back}`);
            this.userId = resp.data.user.data.id;
            this.getCustomerTrasactions(resp.data.user.data.id);
            this.getCustomerNotifications(resp.data.user.data.id);
            this.getCustomerAwards(resp.data.user.data.id);
            this.getCustomerSales(resp.data.user.data.id);
            this.getCustomerOffers(resp.data.user.data.id);
            this.getCustomerStats(resp.data.user.data.id);
            this.getUserGuarantees(resp.data.user.data.id);
            this.getCustomerReceipts(resp.data.user.data.id);

        });
    }

    getCustomerTrasactions(customerId: any) {
        //let filter = '';
        this.api.getCustomerTransactions(customerId, this.filter).subscribe((resp: any) => {
            debugger;
            this.customerTransactions = resp.data;
        });
    }

    getCustomerNotifications(id: any) {
        this.api.getCustomerNotifications(id).subscribe((res: any) => {
            this.notifications = res.data;
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        });
    }

    getCustomerAwards(id: any) {
        this.api.getCustomerAwards(id, '?include=guarantees').subscribe((res: any) => {
            debugger;
            this.awards = res.data;
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        });
    }

    getCustomerSales(id: any) {
        this.api.getCustomerSales(id).subscribe((res: any) => {
            debugger;
            this.sales = res.data;
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        });
    }

    getCustomerOffers(id: any) {
        this.api.getCustomerOffers(id).subscribe((res: any) => {
            debugger;
            this.offers = res.data;
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        });
    }

    changeTrxnStatus(id: any, status: any) {
        this.api.changeTransactionStatus(id, status).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
            this.getCustomer(this.id);
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

        });
    }

    pageChanged(event: any, tbl: string) {
        event = event;
        this.currentPage = this.currentPage;
        switch (tbl) {
            case 'transactions':
                this.getCustomerTrasactions(this.userId);
                break;
            case 'awards':
                this.getCustomerAwards(this.userId);
                break;
            case 'guarantees':
                this.getUserGuarantees(this.userId);
                break;
            case 'receipts':
                this.getCustomerReceipts(this.userId);
                break;
            case 'obligedGuarantees':
                break;
            case 'sales':
                this.getCustomerSales(this.userId);
                break;
            case 'offers':
                break;
            case 'notifications':
                this.getCustomerNotifications(this.userId);
                break;
            default:
                this.getCustomerTrasactions(this.userId);
        }
    }

    changeStatus(ekub: any, user: any, code: any, status: any) {
        debugger;
        var dto = {
            ekub: ekub,
            member: user,
            code: code,
            status: status,
            remark: ""
        };
        this.api.changeUserekubStatus(dto).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: "Ekub Status sucessfully changed", type: 'info' });
            this.getCustomer(this.id);
        }, (err: any) => {
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    changeNotificationStatus(id: any, status: any) {
        this.api.changeNotificationStatus(id, status).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: "Notification Status sucessfully changed", type: 'info' });
            this.getNotificationsFilter();
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

        });
    }

    addNotification(id: any) {
        debugger;
        //this.isLoading = !this.isLoading;
        this.notification = this.notificationForm.value;
        this.notification.user = this.userId;
        this.api.createNotification(this.notification, id).subscribe((res: any) => {
            debugger;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Success', body: (id) ? 'Notification successfully updated! ' : 'Notification  successfully added!', type: 'dark' });
            this.getCustomerNotifications(this.userId);
        }, (err) => {
            err = err;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Success', body: (id) ? 'Could not updaten otification!' : 'Could not add notification!', type: 'danger' });
        });
    }


    setNotification(notification: any) {
        debugger;
        this.notification = notification;
        this.title.setValue(notification.title);
        this.user.setValue(notification.user);
        this.content.setValue(notification.content);
        this.type.setValue(notification.type);
        this.status.setValue(notification.status);
    }

    getNotificationsFilter() {
        this.filter = this.typeFilter + this.statusFilter;
        this.getCustomerNotifications(this.userId);
    }

    getTransactionFilter() {
        debugger;
        this.filter = this.statusFilter + this.typeFilter;
        this.getCustomerTrasactions(this.customer.user.data.id);
    }

    getCustomerStats(userID) {
        debugger;
        //this.isLoading = !this.isLoading;
        this.notification = this.notificationForm.value;
        this.api.getUserStats(userID).subscribe((res: any) => {
            debugger;
            //this.isLoading = !this.isLoading;
            this.userStats = res.data;
        }, (err) => {
            err = err;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Error', body: 'Could not fetch user stats!', type: 'danger' });
        });
    }


    getUserGuarantees(userID) {
        debugger;
        this.api.getUserGuarantees(userID).subscribe((res: any) => {
            debugger;
            this.guarantees = res.data;
        }, (err) => {
            err = err;
            this.mainService.toast({ title: 'Error', body: 'Could not fetch user guarantees as guarantor!', type: 'danger' });
        });
    }

    changeGuaranteeStatus(id: string, status: string) {
        this.api.changeGuaranteeStatus(id, status).subscribe((res: any) => {
            debugger;
            this.getUserGuarantees(this.userId);
        }, (err) => {
            err = err;
            this.mainService.toast({ title: 'Error', body: 'Could not fetch user guarantees as guarantor!', type: 'danger' });
        });
    }

    getCustomerReceipts(userID) {
        debugger;
        this.api.getUserReceipts(userID, this.currentPage, this.filter).subscribe((res: any) => {
            debugger;
            this.receipts = res.data;
        }, (err) => {
            err = err;
            this.mainService.toast({ title: 'Error', body: 'Could not fetch user receipts!', type: 'danger' });
        });
    }

    setReceipt(receipt: any) {
        debugger;
        this.receipt = receipt;
        this.ekub.setValue(receipt.ekub);
        this.user.setValue(receipt.user);
        this.issued_date.setValue(receipt.issued_date);
        this.amount.setValue(receipt.amount);
        this.vat.setValue(receipt.vat);
        this.total.setValue(receipt.total);
        this.receiptStatus.setValue(receipt.status);
    }

    calculateReceiptTotal() {
        debugger;
        var vat = this.amount.value * 0.15;
        this.vat.setValue(vat);
        this.total.setValue(Math.ceil(this.amount.value + vat));
    }

    getReceiptsFilter() {
        debugger;
        this.filter = this.ekubFilter + this.receiptStatusFilter;
        this.getCustomerReceipts(this.userId);
    }


    addReceipt(id: any) {
        debugger;
        if (this.files.length <= 0) {
            this.mainService.toast({ title: 'Warning', body: 'Please add receipt picture!', type: 'warning' });
            return;
        }
        debugger;
        //this.isLoading = !this.isLoading;
        this.receipt = this.receiptForm.value;
        this.receipt.user = this.userId;
        this.api.createReceipt(this.receipt, id).subscribe((res: any) => {
            debugger;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Success', body: (id) ? 'Receipt successfully updated! ' : 'Receipt  successfully added!', type: 'dark' });
            if (this.files.length > 0) {
                this.uploadFile(res.data);
            }
            this.getCustomerReceipts(this.userId);
        }, (err) => {
            err = err;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Error', body: (id) ? 'Could not updaten receipt!' : 'Could not add receipt!', type: 'danger' });
        });
    }


    changeReceiptStatus(id: any, status: any) {
        this.api.changeReceiptStatus(id, status).subscribe((res: any) => {
            this.mainService.toast({ title: 'Success', body: "Receipt Status sucessfully changed", type: 'info' });
            this.getReceiptsFilter();
        }, (err) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

        });
    }



    // File upload

    onSelect(event) {
        console.log(event);
        this.files.push(...event.addedFiles);
        console.log(this.files);
    }

    onRemove(event) {
        console.log(event);
        this.files.splice(this.files.indexOf(event), 1);
        console.log(this.files);

    }

    onFilesAdded(files: any) {
        let j = 0;
        this.files = files.addedFiles;
        console.log('this.files');
        console.log(this.files);
        for (let file of this.files) {
            if (j > 4) {
                break;
            }
            let fileName: any;
            fileName = file['name'];
            if (file) {
                const reader = new FileReader();
                reader.onload = (event: any) => {
                    this.localUrl = event.target.result;
                    this.compressFile(this.localUrl, fileName);
                }
                reader.readAsDataURL(file);
            }
            j++;
        }
    }

    compressFile(image: any, fileName: string) {
        var orientation = -1;
        this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
        // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
        this.imageCompress.compressFile(image, orientation, 50, 50).then(
            result => {
                this.imgResultAfterCompress = result;
                this.localCompressedURl = result;
                this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
                // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
                const imageName = fileName;
                const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
                const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
                this.files_temp.push(imageFile);
            });
        console.log('this.files_temp');
        console.log(this.files_temp);
    }


    dataURItoBlob(dataURI: any) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        return blob;
    }


    public async uploadFile(item: any) {
        debugger;
        this.successUploadCount = 0;
        this.failedUploadCount = 0;
        /* for (let file of this.files) { */
        for (let file of this.files_temp) {
            console.log(file);
            const formData = new FormData();
            if (file instanceof File) {
                formData.append('file', file, file.name);
                formData.append('item_id', item.id);
                formData.append('designation', 'receipt');
                this.uploading = true;
                await this.mainService.upload(formData).then((res: any) => {
                    debugger;
                    this.uploadResponse = res;
                    console.log(res);
                    if (this.uploadResponse.status !== 'progress' &&
                        this.uploadResponse.status !== 'unhandeled event') {
                        this.successUploadCount++;
                        let temp = (this.successUploadCount / this.files.length) * 100;
                        this.uploadResponse.message = temp.toString();
                    }
                }, function (err) {
                });
            }

        }
        this.mainService.toast({ title: 'Success', body: (this.id) ? 'Receipt pictures successfully updated! ' : 'Receipt pictures successfully added!', type: 'dark' });

    }


    setReceiptUrl(receipt: string) {
        debugger;
        this.selectedReceipt = receipt;
    }


}
